import React, { FC } from 'react';
import styled from 'styled-components';
import { globalTheme } from '@cld/component-theme';
import { Selectable, SelectableProps } from '../Selectable';
import { Logo, LOGO_WIDTH, LOGO_HEIGHT } from './Logo';

export const SmallImg = styled.img`
  padding: ${globalTheme.spacing.xxs};
  object-fit: contain;
  display: block;
  width: ${LOGO_WIDTH}px;
  height: ${LOGO_HEIGHT}px;
`;

export interface SelectableLogoProps extends SelectableProps {
  publicId: string,
}

export const SelectableLogo: FC<SelectableLogoProps> = ({ isSelected, onClick, publicId, ...rest }) => (
  <Selectable isSelected={isSelected} onClick={onClick} {...rest}>
    <Logo publicId={publicId}>
      {(logoSrc: string) => <SmallImg src={logoSrc} />}
    </Logo>
  </Selectable>
);
